import DeviceContext from "@/components/generic/customHooks/indentifyDevice";
import React from "react";
import { Col, Row } from "react-bootstrap";
interface IQuoteHead {
  icon?: React.ReactElement;
  title?: string;
  mainHead?: React.ReactElement;
}

const QuoteHead = (props: IQuoteHead) => {
  const device = DeviceContext();
  return (
    <>
      <Row className="mx-0">
        <Col lg={12} className="px-0 quoteHead-section">
          <span className="icondata">{props.icon}</span>
          {props.title && (
            <span
              className={
                device && device.isDesktop
                  ? "DMSansMedium_20_500 ps-2"
                  : "DMSanM_14_500 ps-2"
              }
            >
              {props.title}
            </span>
          )}
          {props.mainHead && <span> {props.mainHead} </span>}
        </Col>
      </Row>
    </>
  );
};

export default QuoteHead;
